import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', 'ResolutionCenter/ScanBack')

export const UPDATE_VIP_REQUEST_ASYNC = createAsyncTypes(
  'UPDATE_VIP_REQUEST',
  'ResolutionCenter/ScanBack'
)
